export default "__VITE_ASSET__fdcd6399__"